import { useCallback, useState } from 'react';

import { useRefreshCurrentUser } from './use-refresh-current-user';
import { workspacesProvision } from '../../core/api';

export const useMarkSfaUserSetupComplete = () => {
  const [isBusy, setIsBusy] = useState(false);
  const { refreshCurrentUser } = useRefreshCurrentUser();

  const markSfaUserSetupComplete = useCallback(
    async (workspaceName: string | null, businessId: string, userEmail: string) => {
      setIsBusy(true);
      try {
        await workspacesProvision(workspaceName, null, null, businessId, userEmail, 'external');
        await refreshCurrentUser(true);
      } catch (e) {
        // Failed - what to do?
      } finally {
        setIsBusy(false);
      }
    },
    [refreshCurrentUser]
  );

  return {
    isBusy,
    markSfaUserSetupComplete
  };
};
